export const isExternalLink = (href = "") => {
  try {
    return new URL(href).origin !== window.location.origin;
  } catch {
    return false;
  }
};
